import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../Firebase/Firebase.utils";
import PageHeader from "../components/PageHeader";
import { SERVICES } from "../utils/services";

const SETTINGS_COLLECTION = "pageSettings";

export default function ServicesList() {
  const [settingsByKey, setSettingsByKey] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        // One read of the whole pageSettings collection. It will only ever
        // hold a handful of docs (insights/blogs/news + the services), so
        // a single getDocs is cheap and avoids per-card N+1 round trips.
        const snap = await getDocs(collection(db, SETTINGS_COLLECTION));
        const map = {};
        snap.forEach((d) => {
          map[d.id] = d.data();
        });
        if (active) setSettingsByKey(map);
      } catch (err) {
        console.error("[ServicesList] failed to load page settings:", err);
      } finally {
        if (active) setIsLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div>
      <PageHeader
        title="Services pages"
        subtitle="Edit the heading and SEO metadata for each services page on the public site. More controls coming as we expand each page's CMS surface."
      />

      <div className="grid gap-3 sm:gap-4 grid-cols-1 md:grid-cols-2">
        {SERVICES.map((service) => {
          const settings = settingsByKey[service.key];
          const hasCustom = !!(
            settings &&
            (settings.heading ||
              settings.metaTitle ||
              settings.metaDescription)
          );
          return (
            <Link
              key={service.key}
              to={`/cms/services/${service.key}`}
              className="group bg-white rounded-2xl ring-1 ring-gray-100 hover:ring-leechiuBlue/20 hover:shadow-md transition-all p-5 flex items-start justify-between gap-4"
            >
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <h3 className="text-sm font-semibold text-leechiuBlue m-0">
                    {service.label}
                  </h3>
                  {isLoading ? null : hasCustom ? (
                    <span className="text-[10px] font-medium text-emerald-700 bg-emerald-50 px-1.5 py-0.5 rounded-full ring-1 ring-emerald-200">
                      Customized
                    </span>
                  ) : (
                    <span className="text-[10px] font-medium text-gray-500 bg-gray-50 px-1.5 py-0.5 rounded-full ring-1 ring-gray-200">
                      Default
                    </span>
                  )}
                </div>
                <p className="text-xs text-gray-500 mb-3">
                  {service.description}
                </p>
                <div className="text-[11px] font-mono text-gray-400 truncate">
                  {service.path}
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-leechiuBlue transition-colors flex-shrink-0 mt-1" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
